import { SubscriberListUrlSortField } from "@saleor/subscribers/urls";
import { SubscriptionSortField } from "@saleor/types/globalTypes";
import { createGetSortQueryVariables } from "@saleor/utils/sort";

export function getSortQueryField(
  sort: SubscriberListUrlSortField
): SubscriptionSortField {
  switch (sort) {
    case SubscriberListUrlSortField.name:
      return SubscriptionSortField.ID;
    case SubscriberListUrlSortField.email:
      return SubscriptionSortField.EMAIL;
    case SubscriberListUrlSortField.subscribed:
      return SubscriptionSortField.SUBSCRIBED;
      case SubscriberListUrlSortField.unsubscribed:
        return SubscriptionSortField.UNSUBSCRIBED;
    default:
      return undefined;
  }
}
export const getSortQueryVariables = createGetSortQueryVariables(
  getSortQueryField
);
